import { atom } from 'jotai';

import { ProjectIdColor } from '@/types/ProjectIdColor';
import { TimeSheetPayPeriod } from '@/types/TimeSheetPayPeriod';
import { getClosestPayPeriod, RequestedPayPeriod } from '@/utility/dateUtils.ts';

const today = new Date();

export const globalDayCardStateAtom = atom<'open' | 'closed' | null>('open');
export const hideEmptyDaysAtom = atom<boolean>(false);
export const isDataLoadingAtom = atom<boolean>(false);
export const payPeriodAtom = atom<TimeSheetPayPeriod | undefined>(undefined);
export const payPeriodHasTimeEntriesAtom = atom<boolean>(false);
export const projectIdColorsAtom = atom<ProjectIdColor[] | undefined>(undefined);
export const requestedPayPeriodAtom = atom<RequestedPayPeriod>(getClosestPayPeriod(today));
export const selectedDateForPayPeriodAtom = atom<Date>(today);
export const someTimeEntriesAreOpenAtom = atom<boolean>(false);
export const someTimeEntriesAreSubmittedAtom = atom<boolean>(false);
export const totalHoursPerDayAtom = atom<Map<string, number>>(new Map());
export const userIsW2Atom = atom<boolean>(true);
export const externalTimeSheetImportToDateAtom = atom<Date>(getClosestPayPeriod(today).endDate);
export const externalTimeSheetImportFromDateAtom = atom<Date>(getClosestPayPeriod(today).beginDate);
